import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { login } from '../api/auth';
import { setCookie } from '../utils/cookies';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const { token } = await login(username, password);
      setCookie('token', token, 2); // Store token in cookies for 1 day
      setMessage('Inicio de sesión exitoso!');
      setTimeout(() => {
        window.location.href = '/home';
      }, 1000);
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-6 text-center text-gray-800">Inicio de Sesión</h1>
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Correo Electrónico"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 transition duration-200"
          >
            Iniciar Sesión
          </button>
        </form>
        {message && (
          <p
            className={`mt-4 text-center font-semibold ${
              message.includes('exitoso') ? 'text-green-500' : 'text-red-500'
            }`}
          >
            {message}
          </p>
        )}
        <div className="mt-6 flex justify-center">
          <button
            onClick={() => window.location.href = '/'}
            className="bg-gray-500 text-white w-full rounded-lg py-2 hover:bg-gray-600 transition duration-200"
          >
            Volver a Lista de Precios
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
